import React from 'react';
import Input from '../../../Components/Input';
import DimensionSelector from '../DimensionSelector';
import TypographySelector from '../TypographySelector';
import PositionSelector from '../PositionSelector';
import { BuilderActionType, BuilderContext } from '../state';
import VendexElement, {
    VendexMultilineMeta,
} from '../../../Model/VendexElement';
import { BuilderField, BuilderFieldGrid } from '../BuilderFields';

type Props = {
    element: VendexElement;
};

function MultilinetDetail({ element }: Props) {
    const data = element.metaData as VendexMultilineMeta;

    const { dispatch } = React.useContext(BuilderContext);

    const handleChange = (value: VendexElement) => {
        dispatch({
            type: BuilderActionType.UPDATE_ELEMENT,
            payload: value,
        });
    };

    const handleDataChange = (name: string, value: string) => {
        handleChange({
            ...element,
            metaData: { ...data, [name]: value },
        });
    };

    return (
        <>
            <BuilderFieldGrid>
                <BuilderField label="Name">
                    <Input
                        onChange={(e) => {
                            handleDataChange('name', e.target.value);
                        }}
                        value={data.name}
                    />
                </BuilderField>
                <BuilderField label="Placeholder">
                    <Input
                        onChange={(e) => {
                            handleDataChange('placeholder', e.target.value);
                        }}
                        value={data.placeholder ? data.placeholder : ''}
                    />
                </BuilderField>
            </BuilderFieldGrid>
            <TypographySelector
                selector={`#${element.id}`}
                hasAlignment={false}
            />
            <PositionSelector selector={`#${element.id}`} />
            <DimensionSelector selector={`#${element.id}`} />
        </>
    );
}

export default MultilinetDetail;
